import { CancelTokenSource } from 'axios';
import {
  StockOrderDto,
  StockOrderSearchRequest,
  UpsertStockOrderDto
} from 'ts-types/api.types';
import axios from 'services/http';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/stock-orders`;


export const getAllStockOrders = (
    source: CancelTokenSource): Promise<Array<StockOrderDto>> => {

  return axios
      .get(apiUri, { cancelToken: source.token })
      .then(response => response.data);
};

export const searchStockOrders = (stockOrderSearchRequest: Partial<StockOrderSearchRequest>,
                                     source: CancelTokenSource): Promise<Array<StockOrderDto>> => {

  return axios
      .post(`${apiUri}/search`, stockOrderSearchRequest, {cancelToken: source.token})
      .then(response => response.data)

};

export const findStockOrderById = (
    id: number, source: CancelTokenSource): Promise<UpsertStockOrderDto> => {

  return axios
      .get(`${apiUri}/${id}`, { cancelToken: source.token })
      .then(response => response.data);
};

export const addStockOrder = (
    upsertStockOrderDto: Partial<UpsertStockOrderDto>,
    source: CancelTokenSource)
    : Promise<StockOrderDto> => {

  return axios
      .post(apiUri, upsertStockOrderDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editStockOrder = (
    id: number,
    upsertStockOrderDto: Partial<UpsertStockOrderDto>,
    source: CancelTokenSource)
    : Promise<StockOrderDto> => {

  return axios
      .put(`${apiUri}/${id}`,upsertStockOrderDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteStockOrder = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const deliverStockOrder = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .put(`${apiUri}/deliver/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
